import { V2StaticLegislationBriefing } from '../../components/static-legislation-briefing/V2StaticLegislationBriefing'
import { V2ProductRegulationPageShell } from './V2ProductRegulationPageShell'

type V2ProductWeeeRegulationPageProps = {
  productId: string
}

export function V2ProductWeeeRegulationPage({
  productId,
}: V2ProductWeeeRegulationPageProps) {
  return (
    <V2ProductRegulationPageShell productId={productId} law="weee">
      {(applies) => <V2StaticLegislationBriefing law="weee" applies={applies} />}
    </V2ProductRegulationPageShell>
  )
}
